
@if (offer.stockDisabled) {
	<div class="_stockout">
		<div>{{'sold_out' | translate}}</div>
	</div>
} @else if ($storage.order?.offerCounters[offer?.offer]) {
	<div class="card-img-marketing i-counter card-brand"><div>{{ $storage.order?.offerCounters[offer?.offer] }}</div></div>
} @else if (offer.offerBadge) {
	<div class="card-img-marketing card-brand">
		<div>{{ ('BADGES.' + offer.offerBadge) | translate }}</div>
		<div class="i-counter">{{$storage.order?.offerCounters[offer?.offer]}}</div>
	</div>
} @else if (offer.marketting) {
	<div class="card-img-marketing card-brand">
		<div>{{ 'name' | objTranslate: offer.marketting }}</div>
		<div class="i-counter">{{$storage.order?.offerCounters[offer?.offer]}}</div>
	</div>
} @else if ($storage.order?.offerCounters[offer?.offer]) {
	<div class="card-img-marketing i-counter card-brand"><div>{{ $storage.order?.offerCounters[offer?.offer] }}</div></div>
}

<!--
<div *ngIf="offer.stockDisabled" class="_stockout"><img [src]="appService.stockImg" /></div>
<div class="_badge {{offer.offerBadge}}" *ngIf="offer.offerBadge"><cap>{{('BADGES.' + offer.offerBadge) | translate}}</cap></div>
<div class="_counter" *ngIf="$storage.order.offerCounters[offer.offer]">{{$storage.order.offerCounters[offer.offer]}}</div>
-->
